import request from "../request";

export const getFlags = () =>
  request.get("setting/flags").then((res) => res);

export const createFlag = (data) =>
  request.post("setting/flags", data).then((res) => res);

export const updateFlag = (id, data) =>
  request.put(`setting/flags/${id}`, data).then((res) => res);

export const deleteFlag = (id) =>
  request.delete(`setting/flags/${id}`).then((res) => res);
